import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { CallAction } from './call.actions';
import { CallApiService } from './call.api.service';

@Injectable()
export class CallEffects {
  constructor(
    private readonly callApiService: CallApiService,
    private readonly action$: Actions<CallAction>,
  ) {}
}
